export const commonStyles = (FOUNDATIONS) => ({
    animationDuration: FOUNDATIONS.duration_100,
});
export const containerCommonStyles = (FOUNDATIONS) => ({
    display: 'inline-block',
    cursor: 'pointer',
});
export const smallContainerCommonStyles = (FOUNDATIONS) => ({
    ...containerCommonStyles(FOUNDATIONS),
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
    align_content: 'center',
});
export const mediumContainerCommonStyles = (FOUNDATIONS) => ({
    ...containerCommonStyles(FOUNDATIONS),
    width: FOUNDATIONS.size_350,
    height: FOUNDATIONS.size_350,
    align_content: 'center',
});
export const largeContainerCommonStyles = (FOUNDATIONS) => ({
    ...containerCommonStyles(FOUNDATIONS),
    width: FOUNDATIONS.size_425,
    height: FOUNDATIONS.size_425,
    align_content: 'center',
});
export const smallIconCommonStyles = (FOUNDATIONS) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
});
export const mediumIconCommonStyles = (FOUNDATIONS) => ({
    width: FOUNDATIONS.size_350,
    height: FOUNDATIONS.size_350,
});
export const largeIconCommonStyles = (FOUNDATIONS) => ({
    width: FOUNDATIONS.size_425,
    height: FOUNDATIONS.size_425,
});
//# sourceMappingURL=commonStyles.js.map